import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import FullScreenLoader from "@components/FullScreenLoader";
import Header from "@container/Header";
import Sidebar from "@container/Sidebar";

const LayoutRoot = styled(Box, {
  name: "layout-root",
  slot: "root"
})({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  overflow: "hidden"
});

const ContentWrapper = styled(Box, {
  name: "content-wrapper",
  slot: "root"
})({
  display: "flex",
  flex: 1,
  overflow: "hidden"
});

const MainContent = styled(Box, {
  name: "main-content",
  slot: "root"
})({
  flex: 1,
  overflow: "auto"
});

/**
 * BaseUI / Shell Layout
 * Mirrors sage-network's BaseUI container pattern
 * Wraps all authenticated routes with Header + Sidebar + Content area
 */
const BaseLayout: React.FC = () => {
  return (
    <LayoutRoot>
      <Header />
      <ContentWrapper>
        <Sidebar />
        <MainContent role="main" id="main-content">
          <Suspense fallback={<FullScreenLoader />}>
            <Outlet />
          </Suspense>
        </MainContent>
      </ContentWrapper>
    </LayoutRoot>
  );
};

export default BaseLayout;
